import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Subject, mergeMap, Subscription } from 'rxjs';
import { FacadeKey, isFacadeKey } from '@lib.core/view/view-key';
import { LoggerService } from '@lib.core/logger/logger.service';
import { FacadeKeyStorageService } from '@public/src/app/store/store-access/facade-key-storage.service';

@Injectable({
  providedIn: 'root'
})
export class FacadeKeyQParamInteractor {
  private facadeKeyStorageService: FacadeKeyStorageService = inject(FacadeKeyStorageService);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly facadeKeyParam = 'facadeKey';
  private readonly defaultFacadeKey: FacadeKey = 'chart';
  private readonly subscriptions: Subscription[] = [];
  private logger: LoggerService = LoggerService.getLoggerService();
  private readonly qParamReaderTrigger$$ = new Subject<void>();
  private readonly qParamReaderTrigger$ = this.qParamReaderTrigger$$.asObservable();

  constructor() {
    this.subscribeToQParamReader();
  }

  readFacadeKeyFromQParam() {
    this.qParamReaderTrigger$$.next();
  }

  destroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  private subscribeToQParamReader() {
    this.subscriptions.push(
      this.qParamReaderTrigger$.pipe(
        mergeMap(() => this.activatedRoute.queryParams),
        map(qp => this.normalizeFacadeKey(qp[this.facadeKeyParam]))
      )
      .subscribe({
        next: (facadeKey: FacadeKey) => {
          this.facadeKeyStorageService.setFacadeKey(facadeKey);
        },
        error: (error) => this.logger.error(error),
      })
    );
  }

  private normalizeFacadeKey(facadeKey: string | null | undefined): FacadeKey {
    if (!facadeKey) {
      return this.defaultFacadeKey;
    } else if (facadeKey === 'map' || isFacadeKey(facadeKey)) {
      return facadeKey === 'map' ? 'mapbox' : facadeKey as FacadeKey;
    } else {
      return this.defaultFacadeKey;
    }
  }
}
